// src/pages/PainelChamados/FormularioTipoServico.jsx
import { X, Wrench } from "lucide-react";
import { useState, useEffect } from "react";
import MenuTipoServico from "./MenuTipoServico"; // 🔗 importa menu lateral
import toast from "react-hot-toast";

const API_URL = process.env.REACT_APP_API_URL;

export default function FormularioTipoServico({ onVoltar, onSalvo, item }) {
  const [codigo, setCodigo] = useState("");
  const [tipoServico, setTipoServico] = useState("");

  // classes padrão
  const inputBaseClasses = `
    peer w-full h-10 px-2 border-b border-gray-300
    focus:border-blue-600 focus:ring-0 focus:outline-none
    text-base text-gray-900 bg-gray-100 placeholder-transparent
  `;
  const labelBaseClasses = (value) => `
    absolute left-2 transition-all duration-200 pointer-events-none
    ${
      value
        ? "-top-4 text-sm font-bold text-gray-900"
        : "top-2 text-base text-gray-400"
    }
    peer-focus:-top-4 peer-focus:text-sm peer-focus:font-bold peer-focus:text-gray-900
  `;

  // 🔹 Se for edição, preenche com os dados do item
  useEffect(() => {
    if (item) {
      setCodigo(item.codigo);
      setTipoServico(item.nome);
    } else {
      // se não for edição, gera próximo código
      const fetchUltimoCodigo = async () => {
        try {
          const resp = await fetch(`${API_URL}/tipo-servico/listar.php`);
          const data = await resp.json();

          if (data.status === "sucesso" && data.dados.length > 0) {
            const ultimo = data.dados[data.dados.length - 1];
            const proximoCodigo = String(Number(ultimo.codigo) + 1).padStart(
              3,
              "0"
            );
            setCodigo(proximoCodigo);
          } else {
            setCodigo("001");
          }
        } catch (err) {
          console.error("Erro ao buscar código:", err);
          toast.error("❌ Erro ao buscar código do serviço");
        }
      };

      fetchUltimoCodigo();
    }
  }, [item]);

  // 🔹 Salvar (inserir ou atualizar)
  const handleSalvar = () => {
    if (!codigo || !tipoServico) {
      toast.error("⚠️ Preencha todos os campos antes de salvar!");
      return;
    }

    const url = item
      ? `${API_URL}/tipo-servico/editar.php` // ✅ se for edição
      : `${API_URL}/tipo-servico/inserir.php`;

    const body = item
      ? { id: item.id, codigo, nome: tipoServico }
      : { codigo, nome: tipoServico };

    toast.promise(
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }).then(async (resp) => {
        const data = await resp.json();
        if (data.status !== "sucesso") throw new Error(data.mensagem || "Erro");
        return data;
      }),
      {
        loading: item
          ? "✏️ Atualizando tipo de serviço..."
          : "💾 Salvando tipo de serviço...",
        success: () => {
          if (onSalvo) onSalvo(); // avisa o pai para recarregar lista
          return item
            ? "✅ Tipo de serviço atualizado com sucesso!"
            : "✅ Tipo de serviço salvo com sucesso!";
        },
        error: "❌ Erro ao salvar tipo de serviço",
      }
    );
  };

  return (
    <div
      className="bg-white rounded-md shadow-sm h-full flex flex-col"
      style={{ border: "1px solid #2b2b2b" }}
    >
      {/* Cabeçalho */}
      <div
        className="flex items-center justify-between px-4 py-3"
        style={{ backgroundColor: "#2b2b2b" }}
      >
        <div className="flex items-center gap-2">
          <Wrench size={20} className="text-white" />
          <h2 className="text-lg font-semibold text-white">
            {item ? "Editando tipo de serviço" : "Cadastro de tipo de serviço"}
          </h2>
        </div>

        <button
          onClick={onVoltar}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-white text-black 
                     transition transform hover:scale-110 hover:bg-slate-200"
          aria-label="Fechar formulário"
        >
          <X size={16} />
        </button>
      </div>

      {/* Conteúdo com menu lateral */}
      <div className="flex flex-1 overflow-hidden">
        {/* Formulário */}
        <div className="flex-1 p-6 space-y-6">
          {/* Campo Código (bloqueado) */}
          <div className="relative w-40">
            <input
              type="text"
              value={codigo}
              readOnly
              placeholder=" "
              className={inputBaseClasses}
            />
            <label className={labelBaseClasses(codigo)}>Código</label>
          </div>

          {/* Campo Tipo de Serviço */}
          <div className="relative w-full">
            <input
              type="text"
              value={tipoServico}
              onChange={(e) => setTipoServico(e.target.value)}
              placeholder=" "
              className={inputBaseClasses.replace("bg-gray-100", "bg-transparent")}
            />
            <label className={labelBaseClasses(tipoServico)}>
              Tipo de Serviço
            </label>
          </div>
        </div>

        {/* Menu lateral */}
        <div className="w-40 border-l border-slate-300 bg-gray-50 flex flex-col p-4">
          <MenuTipoServico onSalvar={handleSalvar} onCancelar={onVoltar} />
        </div>
      </div>
    </div>
  );
}
